export const SELECT_PLACEHOLDER = '-- Select --';
